import { ExportFileStatus } from '@/features/export_files/List/type';
import { useTranslation } from '@/i18n';
import { Status } from '@moneyforward/ap-frontend-components/dist/es/atoms/Tag/Tag';

export const useFileStatusCaption = (status: ExportFileStatus) => {
  const { t } = useTranslation();

  let label = '';
  let colorType: Status = 'default';

  switch (status) {
    case 'processing':
      label = t('export_files_status_progress');
      colorType = 'success';
      break;
    case 'failed':
      label = t('export_files_status_error');
      colorType = 'error';
      break;
    case 'done':
      label = t('export_files_status_completed');
      colorType = 'default';
      break;
    default:
      break;
  }
  return {
    label,
    colorType,
  };
};
